module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAMAAAAcJyCnAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMAlhClIjLr+Ys6BYRqQwjj1sChSAz0x7aRdnQ2Lyza0r+gExIhpOtsAAAAt0lEQVQoz93TSRKCMBRF0SckhAQEFVRa27f/NWqA0BULsDyDDO4kqdT/sLw59GTAuSCD9bouqmoB7A97xGdOSuNrhGSRiMsYj4gYYkd+TzRyYGrFXVd9TPIbN2rErer/QD1tVpm6ekIinNx79lVpEdC5A1kNnTLCkaPKxB6Ad2wqLj4y1bAOYwyEVvY2KxdOMrxszf+zauSgAcKxPuhcRFKQoY0lJ+e4m12gVZy7erCy1QZIYHtbPqYRKOsGMndgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage/num-9.png
// module id = jkSv
// module chunks = 1